import React from "react";
import DesktopProfileLayout from "../desktopLayout/DesktopProfileLayout";
import MobileProfileLayout from "../mobileLayout/MobileProfileLayout";
import { useResponsive } from "../../../hooks/useResponsive";

const ProfileLayout = () => {
  const { mobileOnly } = useResponsive();

  return mobileOnly ? <MobileProfileLayout /> : <DesktopProfileLayout />;
};

export default ProfileLayout;
